import { render } from "./VehicleBpmModal.vue?vue&type=template&id=72681d39"
import script from "./VehicleBpmModal.vue?vue&type=script&lang=js"
export * from "./VehicleBpmModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__